import React, {useState, useEffect} from "react";
import Select from 'react-select';
import button from "../../../button.module.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from '../../../../services/endpoint/endPoint';
import MapDealMultiselectCheckbox from './child/MapDealMultiselectCheckbox';
import './compare-csv.css';
import Listing from "./child/Listing.js";

const CompareCsv = () => {
    const [partnerList, setPartnerList] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState();
    const [selectedDimension, setSelectedDimension] = useState([]);
    const [monthList, setMonthList] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState();
    const [selectedMatrics, setSelectedMatrics] = useState();
    const [selectedCsv, setSelectedCsv] = useState(null);
    const [tableColumn, setTableColumn] = useState([]);
    const [tableRow, setTableRow] = useState([])

    const dimensions = [
        {value: "date", label: "Date"},
        {value: "deal_name", label: "Deal"},
        // {value: "adomain", label: "Adomain"}
    ];
    const matrics = [
        {value: "revenue_BASE", label: "Advertiser Cost"},
        {value: "margin_BASE", label: "Savings"},
        {value: "media_cost_BASE", label: "Media Cost"},
        // {value: "impressions", label: "Impressions"}
    ];

    const getPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.partnerList).then((res) => {
            if (res.status === 200) {
                setPartnerList(res.data.data);
            }
        })
        .catch((error) => {
            if (error) {
                toast.error(error.message, {
                    position: "top-right"
                });
            }
        });
    };

    useEffect(() => {
        getPartnerList();
    }, []);

    const getMonth = () => {
        ApiCallServices.getlisting(END_POINTS.monthList).then((res) => {
            console.log(res)
            if(res.status === 200){
                setMonthList(res.data.data)
            }
        })
        .catch((error) => {
            console.log(error.message, "error.responseerror.response")
            if (error) {
                toast.error(error.message, {
                    position: "top-right"
                });
            }
        });
    }

    useEffect(()=> {
        getMonth() 
    }, [])

    const handleMonthChange = (value) => {
        setSelectedMonth(value)
    }


    const handlePatrenFormChange = (selectedValue) => {
        setSelectedPartner(selectedValue);
    };

    const handleDimensionChange = (value) => {
        console.log(value, "((((((")
        setSelectedDimension(value);
    };

    const selectCsv = (e) => {
        console.log(e.target.files, "fileeeeee")
        setSelectedCsv(e.target.files[0])
    }

    const uploadCsv = (e) => {
        // e.preventDefault();

        if (selectedCsv == undefined || selectedCsv == null) {
        console.log("No file selected.");
        return;
        }

        const formData = new FormData();
        formData.append("file", selectedCsv);
        formData.append("partner_id", selectedPartner?.id);
        // let data = {
        //     partner_id: selectedPartner?.id,
        //     filename: formData,
        // }
        console.log(formData,"datavdata")
        ApiCallServices.fileUpload(END_POINTS.uploadCsv, formData).then((res) => {
            console.log(res)
            if(res.status == 200){
                toast.success(res.data.message, {
                    position: "top-right"
                });
            }  

        })
        .catch((error) => {
            if (error) {
                toast.error(error.message, {
                    position: "top-right"
                });
            }
        });
    }
    console.log(selectedCsv, "selectedCsvselectedCsv")

    useEffect(()=> {
        uploadCsv()
    },[selectedCsv])
    
    const compareCsvData = ()=> {
        let dimensionsVal = selectedDimension?.map((item) => item.value);
        let matricsVal = selectedMatrics?.map((item) => item.value);
        let data = {
            dimensions: dimensionsVal,
            matrics: matricsVal,
            month: selectedMonth?.value,
        }
        console.log(data, "datadatadata")
        ApiCallServices.create(END_POINTS.compareCsv, data).then((res)=> {
            console.log(res, "res*****");
            let response = res.data.data;
            if(res.status == 200){
                setTableColumn(response.column_name)
                setTableRow(response.compare_data)
                // document.querySelectorAll('#myTable th').forEach((cell, i) => {
                //     console.log(cell, "cellcellcell", i, cell.textContent.includes('comp'))
                //     if (cell.textContent.includes('comp')) {
                //         cell.classList.add('highlight');
                //     }
                // });
            }
        })
        .catch((error) => {
            console.log(error, "--->error")
        })
    }

    // useEffect(()=> {
    //     compareCsvData()
    // }, [])
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#fff' : state.isFocused ? '#6abfe94d' : undefined,
            color: state.isSelected ? '#000' : 'black',
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    const handleMatricsChange = (value) => {
        setSelectedMatrics(value)
    }
    console.log(selectedPartner,"******selectedPartner")
    return(
        <>
        <ToastContainer />
        <div className="container-fluid">
            <div className="compare-init">
                <h3 className="title">Follow required 
                    <span> steps 
                        <div className="tool-tip">
                            <p><strong>Step 1:</strong> Prepare .css file to compare data</p>
                            <p><strong>Step 2:</strong> Prepare .css file to compare data</p>
                            <p><strong>Step 3:</strong> Prepare .css file to compare data</p>
                            <p><strong>Step 4:</strong> Click on compare button</p>
                        </div>
                    </span> to compare data with csv: 
                </h3>
                <div className="choose-csv">
                    <div className="form-group custome-select">
                        <Select
                            placeholder="Select Patners"
                            isClearable= "true"
                            value={selectedPartner}
                            onChange={handlePatrenFormChange}
                            options={partnerList}
                            getOptionLabel={(partnerList) => partnerList.name}
                            getOptionValue={(partnerList) => partnerList.id}
                        />
                    </div> 
                    
                    {/* {selectedPartner !== undefined && selectedPartner !== null &&  */}
                    <>
                    <div className="form-group">
                        <input type="file" className="form-control" onChange={selectCsv} disabled={selectedPartner === undefined || selectedPartner === null ? 'disabled': null }/>
                    </div>
                    <div>
                        <span><strong>Note : </strong> Download sample csv file for: <a href="../../../../assets/files/equative-data.csv" download="equative-data"> Equative </a> , <a href="" download="smaato-data"> smaato</a> <a href="" download="indexExchange-data"> Index Exchange</a> <a href="" download="openX-data"> openX</a> <a href="" download="loopme-data"> Loopme</a></span>
                    </div>
                    </>
                {/* } */}
                </div>
                <div className='filter-wraper justify-content-between'>
                    <div className='d-flex align-items-center fields flex-wrap'>
                        <div className="form-group custome-select multicheck">
                            <Select
                                placeholder="Select Dimensions"
                                value={selectedDimension}
                                isMulti={true}
                                hideSelectedOptions={false}
                                closeMenuOnSelect={false}
                                onChange={handleDimensionChange}
                                options={dimensions}
                                components={{ Option: MapDealMultiselectCheckbox }}
                                styles={customStyles}
                            />
                        </div>
                        <div className="form-group custome-select multicheck">
                            <Select
                                placeholder="Select Matrics"
                                value={selectedMatrics}
                                isMulti={true}
                                hideSelectedOptions={false}
                                closeMenuOnSelect={false}
                                onChange={handleMatricsChange}
                                options={matrics}
                                components={{ Option: MapDealMultiselectCheckbox }}
                                styles={customStyles}
                            />
                        </div>
                        <div className="form-group custome-select">
                            <Select
                                placeholder="Select Date"
                                value={selectedMonth}
                                isSearchable={false}
                                onChange={handleMonthChange}
                                options={monthList}
                                
                            />
                        </div>
                    </div>
                    <div className=' d-flex justify-content-end'>
                        <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} onClick={compareCsvData}>Compare</button>
                    </div>
                </div>
            </div>
        {tableColumn && tableColumn.length ? (
            <Listing tableColumn={tableColumn} tableRow={tableRow}/>
        ) : ''
        }
            
         </div>
        </>
    )
}

export default CompareCsv;